module.exports = __webpack_public_path__ + "static/media/ENGProjectPreview3w1100@2x.8d9e684c.webp";